import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from '../../app/common/libs/http';

export const setupChatUser = createAsyncThunk(
  'chat/setupChatUser',
  async (userData, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_APIURL}/user/registerUser`,
        { ...userData, tfNs: [] }
      );
      return response.data;
    } catch (err) {
      // Use `err.response.data` as `action.payload` for a `rejected` action,
      // by explicitly returning it using the `rejectWithValue()` utility
      return rejectWithValue(err.response.data);
    }
  }
);

export const getToken = (identity, campaignId) => {
  return axios
    .post(`${process.env.REACT_APP_APIURL}/token/getToken`, {
      identity,
      campaignId,
    })
    .then((res) => res.data)
    .catch((err) => err.response.data);
};
export const insertAgentActivity = (
  oldActivity,
  newActivity,
  email,
  campaignName,
  campaignId
) => {
  return axios.post(
    `${process.env.REACT_APP_APIURL}/user/insertAgentActivity`,
    {
      oldActivity,
      newActivity,
      email,
      campaignName,
      campaignId,
    }
  );
};
export const getAgentConversations = (
  email,
  searchValue,
  pageNo,
  pageSize,
  type,
  campaignIds,
  userId
) => {
  const data = {
    FriendlyName: searchValue,
    AgentEmail: email,
    pageNo,
    pageSize,
    ChannelType: type,
    CampaignIds: campaignIds,
    UserId: userId,
  };
  return axios.post(
    `${process.env.REACT_APP_APIURL}/conversation/getAgentConversation`,
    data
  );
};

export const getChatHistory = (conversationId) => {
  return axios.get(
    `${process.env.REACT_APP_APIURL}/conversation/getChatHistoryByConversationId/${conversationId}`
  );
};

export const getConversationByUniqueName = (uniqueName) => {
  const data = { UniqueName: uniqueName };
  return axios.post(
    `${process.env.REACT_APP_APIURL}/conversation/getConversationByUniqueName`,
    data
  );
};
export const getConversationById = (id) => {
  const data = { Id: id };
  return axios.post(
    `${process.env.REACT_APP_APIURL}/conversation/getConversationById`,
    data
  );
};

export const acceptIncomingChat = (
  conversationsid,
  agentIdentity,
  agentName,
  email,
  avatarURL,
  userID
) => {
  const data = {
    id: '',
    CustomerConversationSid: conversationsid,
    AgentIdentity: agentIdentity,
    AgentInfo: {
      AgentName: agentName,
      Email: email,
      FriendlyName: agentName,
      AvatarURL: avatarURL,
      IbexAgentId: userID,
    },
    OldParticipantSid: '',
  };
  return axios.post(
    `${process.env.REACT_APP_APIURL}/conversation/acceptIncomingChat`,
    data
  );
};
export const rejectIncomingChat = (
  conversationsid,
  agentIdentity,
  agentName,
  email,
  avatarURL,
  userID
) => {
  const data = {
    id: '',
    CustomerConversationSid: conversationsid,
    AgentIdentity: agentIdentity,
    AgentInfo: {
      AgentName: agentName,
      Email: email,
      FriendlyName: agentName,
      AvatarURL: avatarURL,
      IbexAgentId: userID,
    },
    OldParticipantSid: '',
  };
  return axios.post(
    `${process.env.REACT_APP_APIURL}/conversation/rejectIncomingChat`,
    data
  );
};
export const getRating = (ConversationSid) => {
  return axios.get(
    `${process.env.REACT_APP_APIURL}/conversation/getRating/${ConversationSid}`
  );
};

export const getConversationMessages = (convSid, startIndex, stopIndex) => {
  const data = {
    ConversationSid: convSid,
    PageNo: startIndex,
    PageSize: stopIndex,
  };
  return axios.post(
    `${process.env.REACT_APP_APIURL}/message/getMessages`,
    data
  );
};
export const getMessagesByConversationId = (convSid, startIndex, stopIndex) => {
  const data = {
    ConversationSid: convSid,
    PageNo: startIndex,
    PageSize: stopIndex,
  };
  return axios.post(
    `${process.env.REACT_APP_APIURL}/message/getMessagesHistoryByConversationSid`,
    data
  );
};
export const updateConversationNote = (
  conversationsid,
  title,
  name,
  disposition
) => {
  const data = {
    conversationSid: conversationsid,
    title,
    name,
    disposition,
  };
  return axios.post(
    `${process.env.REACT_APP_APIURL}/conversation/UpdateNote`,
    data
  );
};
export const getConversationBySid = (sid) => {
  const data = { ConversationSid: sid };
  return new Promise((resolve, reject) => {
    axios
      .post(
        `${process.env.REACT_APP_APIURL}/conversation/getConversationBySid`,
        data
      )
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.log('Error in getConversationBySid', error, data);
        resolve({ data: {} });
      });
  });
};
export const endCustomerChat = (
  sid,
  psid,
  identity,
  disposition,
  title,
  notes
) => {
  return axios.post(
    `${process.env.REACT_APP_APIURL}/conversation/endChatByAgent`,
    {
      CustomerConversationSid: sid,
      ParticipantSid: psid,
      CustomerIdentity: identity,
      dispositionName: disposition,
      note: {
        title: title,
        name: notes,
      },
    }
  );
};
export const handOverCustomerChat = (sid, identity, agentInfo, oldPsid) => {
  return axios.post(
    `${process.env.REACT_APP_APIURL}/conversation/handoverCustomerChat`,
    {
      customerConversationSid: sid,
      agentIdentity: identity,
      agentInfo: {
        agentName: agentInfo.name,
        ibexAgentId: agentInfo.ibexId,
        email: agentInfo.email,
        friendlyName: agentInfo.name,
        avatarURL: '',
      },
      oldParticipantSid: oldPsid,
    }
  );
};

export const agentInitChat = (payload) => {
  return axios.post(
    `${process.env.REACT_APP_APIURL}/conversation/initChat`,
    payload
  );
};

export const getConversationByIds = (payload) => {
  return axios.post(
    `${process.env.REACT_APP_APIURL}/conversation/getConversationByIds`,
    payload
  );
};
// export const getOfflinePendingRequests = (identity, campaignId) => {
//   return axios.post(`${process.env.REACT_APP_APIURL}/conversation/getOfflinePendingRequests`, { identity, campaignId })
//     .then(res => res.data).catch(err => err.response.data);
// }

export const getPendingRequests = createAsyncThunk(
  'conversation/getPendingRequests',
  async (campaignIds, { getState }) => {
    const response = await axios.post(
      `${process.env.REACT_APP_APIURL}/conversation/getPendingRequests`,
      {
        campaignIds,
      }
    );
    const user = getState().auth.user;
    return {
      response,
      languageKeys: user.languageKeys,
    };
  }
);
export const getMediaResources = (campaignId, messageId) => {
  return axios.post(
    `${process.env.REACT_APP_APIURL}/message/getMediaResources`,
    {
      campaignId: campaignId,
      messageSids: [messageId],
    }
  );
};
